const doc = [({"zh_tw":({"adminConstantPromotionFixedDiscountApplyTargetType":({"perAdultAndIncludedChildPerStay":"每名成人（及包含在成人價格計算中的兒童）每晚", "perAdultPerStay":"每名成人每晚", "total":"整個預訂"})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;